// ./core/Audio/AudioPlayer.ts

import { IAudio } from './IAudio';
import { AudioFactory } from './AudioFactory';
import { AudioEngineOptions } from './WebHtml5Service';

export class AudioPlayer implements IAudio {
  private provider: IAudio;

  constructor(
    opts: AudioEngineOptions,
    prefer: 'howler' | 'webaudio' = 'webaudio'
  ) {
    this.provider = AudioFactory.create(opts, prefer);
  } // SFX

  play(name: string) {
    this.provider.play(name);
  }
  stop(name: string) {
    this.provider.stop(name);
  }
  playAt(name: string, seekSeconds: number) {
    this.provider.playAt(name, seekSeconds);
  }
  getSfxDuration(name: string) {
    return this.provider.getSfxDuration(name);
  }
  isSfxPlaying(name: string) {
    return this.provider.isSfxPlaying(name);
  }
  noteUserGesture() {
    this.provider.noteUserGesture();
  }
  playWithCallback(name: string, onEnd: () => void) {
    this.provider.playWithCallback(name, onEnd);
  }
  playLoop(name: string) {
    this.provider.playLoop(name);
  }
  stopLoop(name: string) {
    this.provider.stopLoop(name);
  }
  muteSfx() {
    this.provider.muteSfx();
  }
  unmuteSfx() {
    this.provider.unmuteSfx();
  }
  isSfxMuted() {
    return this.provider.isSfxMuted();
  } // Music (MODIFIED: Added new methods)
  playMusic(name: string) {
    this.provider.playMusic(name);
  }
  stopMusic() {
    this.provider.stopMusic();
  }
  muteMusic() {
    this.provider.muteMusic();
  }
  unmuteMusic() {
    this.provider.unmuteMusic();
  }
  isMusicMuted() {
    return this.provider.isMusicMuted();
  }
  isMusicPlaying() {
    return this.provider.isMusicPlaying();
  }
  // Common

  setVolume(vol: number) {
    this.provider.setVolume(vol);
  }
  getVolume() {
    return this.provider.getVolume();
  }
  debugAudioStatus() {
    this.provider.debugAudioStatus();
  }
  dispose() {
    this.provider.dispose();
  }
}
